import abeagle from './abeagle';

const testSlug = 'hp_entry_cta_test';
const { edition, isEntry, features } = window.HP.params;
const { adsFree } = features;
const isUS = edition === 'us';

if (isUS && isEntry && !adsFree && window.HP.params.abeagle && Array.isArray(window.HP.params.abeagle) && window.HP.params.abeagle.includes(testSlug)) {
  document.addEventListener('abeagleEventCambria', () => {
    const variant = abeagle.getExperimentVariant(testSlug);
    if (variant && variant === 'variant1') {
      const supportHuffpost = document.querySelector('#support-huffpost-entry-variant');
      if (supportHuffpost) {
        supportHuffpost.classList.remove('hidden');
      }
    } else {
      const supportHuffpost = document.querySelector('#support-huffpost-entry');
      if (supportHuffpost) {
        supportHuffpost.classList.remove('hidden');
      }
    }
  }, { once: true });
  window.HP.params.abEntryCtaTest.ready = true;
}
